import { createContext, useCallback } from 'react'

import pkceChallenge from 'pkce-challenge'
import { withRouter } from 'react-router-dom/cjs/react-router-dom'

import useLocalStorageOld from '../hooks/UseLocalStorage'
import appConfig from '../config'
import { Routes } from '../routes'
import { loginSSO } from '../utils/api/auth'

export const StorageKeys = Object.freeze({
  CODE_VERIFIER: 'code_verifier',
  ACCOUNT_ID: 'account_id'
})

export const AuthContext = createContext()

const AuthProvider = ({ children, history }) => {
  const [codeVerifier, setCodeVerifier] = useLocalStorageOld(StorageKeys.CODE_VERIFIER, null)
  const [, setAccountId] = useLocalStorageOld(StorageKeys.ACCOUNT_ID, null)
  /**
   * After Auth callback, exchange the authorization code for a token
   */
  const authCallback = useCallback(
    /**
     * @param {string} authorizationCode
     * @param {function} onGetUserContextAndData
     * @param {function} onAfterLogin
     */
    async (authorizationCode, onGetUserContextAndData, onAfterLogin) => {
      const data = await loginSSO(authorizationCode, codeVerifier)

      if (!data) {
        throw new Error('Error getting token')
      }

      setAccountId(data.accountId)

      onGetUserContextAndData(data.token).then(() => {
        onAfterLogin()
      })
    },
    []
  )

  const createCodeChallenge = async () => {
    const challenge = await pkceChallenge()

    setCodeVerifier(challenge.code_verifier)

    return challenge.code_challenge
  }

  const redirectToSSOLoginPage = async (email = null) => {
    const challenge = await createCodeChallenge()

    let url = `${appConfig.opalAuthServeurWebapp}?${appConfig.redirectUrl}&code_challenge=${challenge}`

    if (email) {
      url += `&email=${email}`
    }

    window.location.href = url
  }

  const navigateToLoginPage = async () => {
    history.push(Routes.LOGIN)
  }

  return (
    <AuthContext.Provider
      value={{
        authCallback,
        createCodeChallenge,
        redirectToSSOLoginPage,
        navigateToLoginPage
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default withRouter(AuthProvider)
